import React, {Component} from 'react'
import {Button, Tooltip} from 'antd'
import PropTypes from 'prop-types'

class RefreshButton extends Component {
  render() {
    const {onClick, float, children, ...rest} = this.props
    return (
      <Tooltip title="Refresh">
        <Button
          style={{float}}
          type={'dashed'}
          icon={'retweet'}
          onClick={onClick}
          {...rest}>
          {children}
        </Button>
      </Tooltip>
    )
  }
}

RefreshButton.propTypes = {onClick: PropTypes.func, disabled: PropTypes.bool}
RefreshButton.defaultProps = {size: 'small', float: 'right', disabled: false}

export default RefreshButton
